export default [
    {
        path: 'Fwamework/Setup/Setup.aspx',
        name: 'Setup'
    }
];